module.exports = __webpack_public_path__ + "img/login-foreground.4e396072.png";